import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/_auth/admin/processes/$id/")({
  params: {
    parse(params) {
      return z
        .object({
          id: z.coerce.number(),
        })
        .parse(params);
    },
  },
});
